import React from 'react'
import PropTypes from 'prop-types'

import { FormattedMessage } from '@dragonraider5/react-intl'
import { USER_NOT_FOUND } from 'inbonis-exception/lib'
import { LOGIN_PATH, REGISTER_PATH } from '../../MainRoutes/constants'
import { showFieldError, renderValidation } from '../../../utils/validations'
import { getExceptionMessage } from '../../../utils/exceptions'

import { Link } from 'react-router-dom'
import H1 from '../../../components/H1'
import { SectionWrapper } from '../../../components/Section'
import FormInfo from '../../../components/FormFields/FormInfo'
import FormRow from '../../../components/FormFields/FormRow'
import TextField from '../../../components/FormFields/TextField'
import FormAction from '../../../components/FormFields/FormAction'
import FormError from '../../../components/FormFields/FormError'
import FormLinks from '../../../components/FormFields/FormLinks'

import m from './messages'
import registerMessages from '../../Register/messages'
import SuccessMessage from '../../../components/SuccessMessage'

const renderSuccess = __html => (
  <SuccessMessage dangerouslySetInnerHTML={{ __html }} />
)

function RecoverPasswordForm({
  values,
  errors,
  touched,
  status = {},
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit
}) {
  return (
    <SectionWrapper>
      <H1>
        <FormattedMessage {...m.title} />
      </H1>
      {status.success ? (
        <FormattedMessage {...m.successMessageHTML}>
          {renderSuccess}
        </FormattedMessage>
      ) : (
        <form onSubmit={handleSubmit}>
          <FormInfo>
            <FormattedMessage {...m.info} />
          </FormInfo>
          <FormRow>
            <TextField
              type='email'
              name='username'
              value={values.username}
              onChange={handleChange}
              onBlur={handleBlur}
              error={showFieldError('username', { errors, touched })}
              help={renderValidation('username', { errors, touched })}
              label={<FormattedMessage {...registerMessages.formFieldUsername} />}
              full
            />
          </FormRow>
          {status.error && (
            <FormError>
              <FormattedMessage
                {...getExceptionMessage(status.error, {
                  [USER_NOT_FOUND]: m[USER_NOT_FOUND]
                })}
              />
            </FormError>
          )}
          <FormAction disabled={isSubmitting}>
            <FormattedMessage {...m.submitButton} />
          </FormAction>
        </form>
      )}
      <FormLinks>
        <Link to={LOGIN_PATH}>
          <FormattedMessage {...m.loginLink} />
        </Link>
        <br />
        <Link to={REGISTER_PATH}>
          <FormattedMessage {...m.registerLink} />
        </Link>
      </FormLinks>
    </SectionWrapper>
  )
}

RecoverPasswordForm.propTypes = {
  values: PropTypes.shape({
    username: PropTypes.string.isRequired
  }).isRequired,
  touched: PropTypes.objectOf(PropTypes.bool),
  errors: PropTypes.objectOf(PropTypes.string),
  isSubmitting: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired
}

export default RecoverPasswordForm
